import { Typography } from '@mui/material';
import { FC } from 'react';
import { useSnapshot } from 'valtio';
import ApplicationsTable from '../components/ApplicationsTable/ApplicationsTable';
import ApplicationsFiltersStore from '../stores/applications-filters-store';
import ApplicationsStore from '../stores/applications-store';

const ApplicationTableContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const {
    applications,
    categories,
    selectedAppId,
    loading,
    loadingSingleApp,
    orderField,
    orderDirection,
    orderByCategory,
  } = useSnapshot(ApplicationsStore);

  const { loadingFilters } = useSnapshot(ApplicationsFiltersStore);

  if (!categories || !applications)
    return (
      <Typography variant='body2' color='text.primary'>
        No Applications found
      </Typography>
    );

  return (
    <ApplicationsTable
      applications={applications}
      categories={categories}
      selectedAppId={selectedAppId}
      loading={loading}
      loadingSingleApp={loadingSingleApp}
      loadingFilters={loadingFilters}
      orderField={orderField}
      orderDirection={orderDirection}
      orderByCategory={orderByCategory}
    />
  );
};

export default ApplicationTableContainer;
